import React, { Component } from 'react';
import { Header, Container, Segment, Item } from 'semantic-ui-react'

import { STUDIES } from '../../data/caseStudies';

class CaseStudyPane extends Component {

  render() {

    const studies = STUDIES.slice(0, 5);
    const defaultLink = "http://www.cameronyick.com";

    return (
      <Container style={{ marginBottom: '40px' }}>
        <Segment raised style={{ minHeight: '200px' }}>
          <Header as='h2'>Case Study Solutions</Header>
          <p>
            Looking to take further action? Check out these projectes related to your first chosen scenario that has been implemented in real cities!
          </p>

          <Item.Group divided>
            {studies.map((study, index) => {
              return (
                <Item key={study.Title}>
                  <Item.Content>
                    <Item.Header>#{index + 1}: {study.Title}</Item.Header>
                    <Item.Meta>
                      <span><a href={defaultLink} target="_blank" rel="noopener noreferrer">PDF </a></span>
                      <span><a href={defaultLink} target="_blank" rel="noopener noreferrer">Website </a></span>
                    </Item.Meta>
                    <Item.Meta></Item.Meta>
                    <Item.Description>{study.Descriptions}</Item.Description>
                  </Item.Content>
                </Item>
              )
            })}
          </Item.Group>
        </Segment>
      </Container>
    );
  }
}

export default CaseStudyPane;



// WEBPACK FOOTER //
// ./src/components/caseStudyPane/index.js